/* General PDP variant-size markers. Metafields and resolved variant IDs are authoritative. */
(()=>{'use strict';
if(window.AGProductDimensions){window.AGProductDimensions.scan();return;}
const states=new Map();
function sync(state,id){
 const field=document.getElementById('product-variant-id');
 const selected=String(field&&field.value||id||state.data.selected||'');
 const size=String(state.data.sizes[selected]||'').trim();
 state.root.querySelectorAll('.ag-dims-row').forEach(row=>{
  if(!row.closest('[data-agwc="dims-index"]'))row.toggleAttribute('data-ag-dims-current',!!size&&String(row.dataset.agDimSize||'').trim()===size);
  const sizeNode=row.querySelector('.ag-dims-sz');
  if(sizeNode){
   let choice=row.querySelector('.ag-dims-choice');
   if(!choice){choice=document.createElement('span');choice.className='ag-dims-choice';sizeNode.before(choice);choice.append(sizeNode);}
   let label=row.querySelector('.ag-dim-selected-label');
   if(!label){label=document.createElement('span');label.className='ag-dim-selected-label';label.textContent=state.data.label;}
   if(label.parentElement!==choice)choice.append(label);
  }
 });
 if(parseFloat(state.root.style.maxHeight)>0)state.root.style.maxHeight=state.root.scrollHeight+'px';
}
function schedule(state){if(state.queued)return;state.queued=true;requestAnimationFrame(()=>{state.queued=false;sync(state);});}
function scan(){
 for(const [node,state] of states)if(!node.isConnected){state.observer.disconnect();states.delete(node);}
 document.querySelectorAll('script[data-ag-dim-map]').forEach(node=>{
  if(states.has(node)||node.closest('[data-agwc="dims-index"]'))return;
  let data;try{data=JSON.parse(node.textContent);}catch(_){return;}
  if(!data||typeof data!=='object'||!data.sizes||typeof data.sizes!=='object'||Array.isArray(data.sizes)||typeof data.label!=='string')return;
  const root=node.closest('.product-overview_acc-body')||node.closest('.product-overview_acc-inner')||node.parentElement;
  const state={data,root,queued:false};states.set(node,state);sync(state);
  state.observer=new MutationObserver(()=>schedule(state));
  state.observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['data-agwc-current']});
 });
}
function changed(event){if(event.type!=='variantChange'&&event.target.id!=='product-variant-id')return;for(const state of states.values())sync(state,event.detail&&event.detail.variantId);}
document.addEventListener('change',changed);document.addEventListener('input',changed);document.addEventListener('variantChange',changed);
document.addEventListener('shopify:section:load',scan);
window.addEventListener('resize',()=>states.forEach(schedule));
if(document.fonts)document.fonts.ready.then(()=>states.forEach(schedule));
window.AGProductDimensions={scan};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
})();
